import { render, staticRenderFns } from "./TwTradingDetailInner.vue?vue&type=template&id=1c92cdb0&scoped=true&"
import script from "./TwTradingDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwTradingDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwTradingDetailInner.vue?vue&type=style&index=0&id=1c92cdb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c92cdb0",
  null
  
)

export default component.exports